import {SanityImageType} from '@local/types'
import {SanityImage} from '@local/ui/components'
import Link from 'next/link'

type Experience = {
	item: {
		title: string
		slug: string
		slugPrefix: string
	}
	media : {
		image: SanityImageType
	}
}

type ExperiencesLikeProps = {
	experiences: Experience[]
	heading?: string
	className?: string
}

export const ExperiencesLike = ({
	experiences,
	heading = 'You May Also Like',
	className = '',
}: ExperiencesLikeProps) => {
	if (!experiences || experiences.length === 0) return null

	return (
		<div className={`flex flex-col gap-y-20 pt-20 ${className}`}>
			{heading && <h5>{heading}</h5>}
			{experiences.map((experience) => (
				<ExperienceCard
					key={experience.item.slug}
					experience={experience} />
			))}
		</div>
	)
}

type ExperienceCardProps = {
	experience: Experience
	className?: string
}

const ExperienceCard = ({experience, className = ''}: ExperienceCardProps) => {
	const {item, media} = experience
	const {title, slug, slugPrefix} = item
	const {image} = media

	return (
		<Link href={`/${slugPrefix}/${slug}`} className={`flex flex-row items-center gap-x-20 ${className}`}>
			<SanityImage image={image} className='w-100 h-100 rounded-sm' />
			<div className='flex flex-col'>
				<h5 className='text-18 font-serif text-black font-medium'>{title}</h5>
			</div>
		</Link>
	)
}
